import { SummitFormattedText } from '@summit/models';
import { EboObject } from '../../base-classes/ebo-object';

export class DivisionPolicyRestriction extends EboObject {
  policyId: string;
  startMonth: number; //1 based
  startDay: number; //1 based
  endMonth: number; //1 based
  endDay: number; //1 based

  toSummary(): SummitFormattedText {
    const summary = new SummitFormattedText();
    summary.AddKeyValues('Blocking', `${this.startMonth}/${this.startDay}-${this.endMonth}/${this.endDay}`);
    return summary;
  }
}
